// This file is generated automatically by `scripts/build/fp.ts`. Please, don't change it.

import { secondsToHours as fn } from "../secondsToHours.js";
import { convertToFP } from "./_lib/convertToFP.js";

export const secondsToHours = convertToFP(fn, 1);

// Fallback for modularized imports:
export default secondsToHours;
